import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";
import { SectionEyebrow } from "@/components/Marquee";

export default function Founder() {
  return (
    <section id="story" className="relative py-20 md:py-28 bg-[#0A0A0F] overflow-hidden" data-testid="founder-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 1.03 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1.1, ease: [0.8, 0, 0.2, 1] }}
          className="lg:col-span-5 relative rounded-3xl overflow-hidden border border-white/10 h-[520px]"
        >
          <img src={IMAGES.founder} alt="Founder portrait" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-void" />
          <div className="absolute bottom-6 left-6 right-6">
            <p className="eyebrow gradient-text">The Saarthi</p>
            <p className="mt-2 font-serif text-3xl text-white">Akash, Founder</p>
            <p className="mt-2 text-sm text-silver/70 italic leading-snug max-w-sm">
              "I built CaarSaarthi because buying a car should never mean negotiating alone."
            </p>
          </div>
        </motion.div>
        <div className="lg:col-span-7">
          <SectionEyebrow n="Ch. XIII" testId="founder-eyebrow">The Story</SectionEyebrow>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1 }}
            className="mt-6 font-serif text-white text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight"
          >
            In the Mahabharata, <span className="italic gradient-text">Krishna</span> didn't fight.
            <br />He drove the chariot.
          </motion.h2>
          <div className="mt-8 space-y-5 text-silver/80 leading-relaxed text-lg max-w-xl">
            <p>
              Arjuna was the greatest archer of his age. He still needed a Saarthi — someone who saw the field,
              read the enemy, and made every arrow count.
            </p>
            <p>
              Indian car buyers today are Arjunas. Sharp. Ambitious. Ready to spend serious money. But they walk
              into a battlefield where every soldier — the dealer, the aggregator, the finance manager,
              the insurance agent — is paid by the other side.
            </p>
            <p className="font-serif italic text-white text-2xl">
              We built CaarSaarthi to change one thing: the person driving your chariot works only for you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
